import * as React from 'react';
function BEM(props) {
    const classArray = ['mini-form'];
    if (props.field.hideLabel) {
        classArray.push('mini-form--no-label-' + props.field.hideLabel);
    }
    if (props.className) {
        classArray.push(props.className);
    }
    return classArray.join(' ');
}
const MiniFormCore = (props) => {
    const { onSubmit, field, button } = props;
    const { Button, TextField } = props.components;
    return (React.createElement("form", { className: BEM(props), onSubmit: onSubmit },
        React.createElement(TextField, Object.assign({}, field, { className: "mini-form__field", inputClass: "mini-form__input" })),
        React.createElement(Button, Object.assign({}, button, { className: "mini-form__button", size: "small", attributes: {
                type: 'submit',
            } }))));
};
export default MiniFormCore;
